
import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import MemberList from './MemberList'
import EdiutProject from './EdiutProject'
import Task_management from './Task_management'
import MemberTask_manaement from './MemberTask_manaement'
import Project_files from './Project_files'
import Daily_update from './Daily_update'
import Feedback from './Feedback'
import Project_timetracking from './Project_timetracking'
import Member_projectg_time from './Member_projectg_time'
import Budget_calculation from './Budget_calculation'
import Resource from './Resource'
import Project_issues from './Project_issues'
import $ from 'jquery'

export default function Project_details() {
  const navigate = useNavigate();
  const [userType, setUserType] = useState(''); // 'Admin' or 'Member'
  const [projectDeadline, setProjectDeadline] = useState(''); // 'Admin' or 'Member'
  const idarray = ['members', 'task', 'member_task', 'communication', 'files', 'report', 'feedback', 'time', 'budget', 'resource', 'time_member', 'issue', 'editproject'];
  const [projectGoals, setProjectGoals] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [projectlink, setProjectlinks] = useState('');
  const [inputLink, setInputLink] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
    setPermissions(storedPermissions);
    const deadlinedate = localStorage.getItem('deadline');
    console.log(deadlinedate)
    setProjectDeadline(deadlinedate)
    const adminmember = localStorage.getItem('user_position');
    setUserType(adminmember || 'Member');
  }, []);

  useEffect(() => {
    if (!userType) return; // don't run until userType is known

    const trgcell = localStorage.getItem('initialpage') || 'members';

    idarray.forEach(idval => {
      if (trgcell === idval) {
        $('#' + trgcell).css('display', 'block');
        $('.' + trgcell).addClass('activetabs');
      } else {
        $('#' + idval).css('display', 'none');
        $('.' + idval).removeClass('activetabs');
      }
    });
  }, [userType]);

  useEffect(() => {
    const proid = localStorage.getItem('selected_project_id');

    fetch('get_project_link.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ proid: proid })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setProjectlinks(data.link);
          setInputLink(data.link || '');
        }
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {

    const projectId = localStorage.getItem('selected_project_id');

    if (!projectId) return;

    $.ajax({
      type: 'POST',
      url: 'getGoalsForProject.php',
      data: {
        project_id: projectId
      },
      success: function (res) {

        console.log("Project Goals:", res);

        if (res.success) {

          setProjectGoals(res.goals);

        } else {

          showAlert(res.message);
        }
      }
    });

  }, []);

  const showAlert = (msg) => {
    setAlertMsg(msg);
    setShowAlertBox(true);
  };

  const closeAlert = () => {
    setShowAlertBox(false);
    setAlertMsg('');
  };


  function openControlTabs(typetext) {

    idarray.forEach(idval => {
      if (typetext === idval) {
        console.log('MATCH')
        $('#' + typetext).css('display', 'block');
        $('.' + typetext).addClass('activetabs');
      } else {
        $('#' + idval).css('display', 'none');
        $('.' + idval).removeClass('activetabs');
      }
    });
  }

  function goToProDetails() {
    navigate('/project_details');
  }

  function goForLinkedGoal(goalid) {
    localStorage.setItem('goal_id', goalid);
    navigate('/goal_details');
  }

  const saveLink = () => {
    const proid = localStorage.getItem('selected_project_id');

    fetch('save_project_link.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        proid: proid,
        link: inputLink
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setProjectlinks(inputLink);
          setIsEdit(false);
          alert("Link saved successfully");
        } else {
          alert("Failed to save link");
        }
      });
  };

  function openChatArea() {
    let memtype = localStorage.getItem('membership_type');
    if (memtype === 'free') {
      alert("Please upgrade your membership to use this feature");
    } else {

      // Step 1: Get data from localStorage
      const project_id = localStorage.getItem('selected_project_id');
      const member_id = localStorage.getItem('member_id');
      const company_id = localStorage.getItem('mem_company_id');
      const member_name = localStorage.getItem('membername');
      const project_name = localStorage.getItem('selected_project_name');
      // Step 2: Basic validation
      if (!project_id || !member_id || !company_id) {
        alert("Missing required data. Please reload the page.");
        return;
      }

      // Step 3: Send data to PHP
      fetch("startChat.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          project_id: project_id,
          member_id: member_id,
          company_id: company_id,
          member_name: member_name,
          project_name: project_name
        })
      })
        .then(response => response.json())
        .then(data => {

          if (data.status === "success") {

            // Step 4: Open popup window
            window.open(
              "chatbox.php",
              "chatWindow",
              "width=900,height=600,resizable=yes"
            );

          } else {
            alert("Failed to start chat");
          }

        })
        .catch(error => {
          console.error("Error:", error);
        });
    }
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Sidebar_component sidebarOpen={sidebarOpen} />
      <div className='vl_dsh_bodypart'>
        <div className='top_info_bar'>
          <span className='deadlineinfor'>Project deadline: {projectDeadline}</span>
          <span className='pro_editbtn'><button onClick={() => openControlTabs('editproject')}>View Other Details</button></span>
          <div className="dev-link-box">

            {projectlink ? (
              <>
                <p>
                  <strong>Dev Link: </strong>
                  <a href={projectlink} target="_blank">{projectlink}</a>
                </p>

                {!isEdit && (
                  <button onClick={() => setIsEdit(true)}>
                    Change Link
                  </button>
                )}
              </>
            ) : (
              <p>No development link added<span> (You must add a link here. Otherwise your client cannot see any live link in the auto generated progress report.)</span></p>
            )}

            {(isEdit || !projectlink) && (
              <div>
                <input
                  type="text"
                  value={inputLink}
                  onChange={(e) => setInputLink(e.target.value)}
                  placeholder="Enter development link"
                />

                <button onClick={saveLink}>
                  {projectlink ? 'Update Link' : 'Save Link'}
                </button>
              </div>
            )}

          </div>

        </div>
        {projectGoals.length > 0 && (

          <div className="goalarea fullwidth mt-30 mb-30">

            <h4 className='fullwidth pull_left'>Linked Goals</h4>

            {projectGoals.map((goal) => (

              <div key={goal.id} className="goal_row">

                <p className='pull_left'>
                  <b>{goal.title}</b>
                  {" "}({goal.progress}%)
                </p>

                <p className='pull_left'>&nbsp;&nbsp;Status: {goal.status}</p>

                <button
                  className="small_button ml-10"
                  onClick={() => goForLinkedGoal(goal.id)}
                >
                  View Goal
                </button>

              </div>
            ))}

          </div>
        )}

        <div className='vl_alltab'>
          <button className='tabs members activetabs' onClick={() => openControlTabs('members')}>Members</button>

          {permissions.includes("tasks.view_all") && (
            <button className='tabs task' onClick={() => openControlTabs('task')}>
              Task
            </button>
          )}
          {permissions.includes("task.view_own") && (
            <button className='tabs member_task' onClick={() => openControlTabs('member_task')}>Task</button>
          )}

          <button className='tabs communication' onClick={() => openChatArea()}>Communication</button>
          {permissions.includes("todo.create") && (
            <button className='tabs files' onClick={() => openControlTabs('files')}>Files</button>
          )}

          {permissions.includes("todo.create") && (
            <button className='tabs todo' onClick={() => openControlTabs('report')}>Daily Update</button>
          )}

          <button className='tabs feedback' onClick={() => openControlTabs('feedback')}>Feedback</button>

          {permissions.includes("timesheet.view_all") && (
            <button className='tabs time' onClick={() => openControlTabs('time')}>Time Tracking</button>
          )}

          {permissions.includes("budget.view") && (
            <button className='tabs budget' onClick={() => openControlTabs('budget')}>Budget</button>
          )}



          <button className='tabs resource' onClick={() => openControlTabs('resource')}>Resource</button>

          {permissions.includes("timesheet.view_own") && (
            <button className='tabs time' onClick={() => openControlTabs('time_member')}>Time Tracking</button>
          )}



          <button className='tabs issue' onClick={() => openControlTabs('issue')}>Issue</button>
        </div>

        <section className='vl_dsh_bodypart_section pos_rel'>
          <div className='vl_tab_content'>
            <div className='contentbase mem_list' id="members">
              <MemberList />
            </div>

            <div className='contentbase mem_list' id="editproject">
              <EdiutProject />
            </div>

            {/* ✅ Only load one of these based on user type */}
            {permissions.includes("tasks.view_all") && (
              <div className='contentbase mem_list nodisplay' id="task">
                <Task_management />
              </div>
            )}
            {permissions.includes("task.view_own") && (
              <div className='contentbase mem_list nodisplay' id="member_task">
                <MemberTask_manaement />
              </div>
            )}
            {permissions.includes("todo.create") && (
              <div className='contentbase mem_list nodisplay' id="files">
                <Project_files />
              </div>
            )}
            {permissions.includes("todo.create") && (
              <div className='contentbase mem_list nodisplay' id="report">
                <Daily_update />
              </div>
            )}

            <div className='contentbase mem_list nodisplay' id="feedback">
              <Feedback />
            </div>
            {permissions.includes("timesheet.view_all") && (
              <div className='contentbase mem_list nodisplay' id="time">
                <Project_timetracking />
              </div>
            )}
            {permissions.includes("timesheet.view_own") && (
              <div className='contentbase mem_list nodisplay' id="time_member">
                <Member_projectg_time />
              </div>
            )}
            {permissions.includes("budget.view") && (
              <div className='contentbase mem_list nodisplay' id="budget">
                <Budget_calculation />
              </div>
            )}

            <div className='contentbase mem_list nodisplay' id="resource">
              <Resource />
            </div>

            <div className='contentbase mem_list nodisplay' id="issue">
              <Project_issues />
            </div>


          </div>
        </section>
      </div>
      {showAlertBox && (
        <div className='vl_dsh_popup'>
          <div className='alertbox'>
            <div className='alertheader'>
              <h3><i className='ri-alert-line'></i>Alert</h3>
            </div>

            <div className='contentarea'>
              <p>{alertMsg}</p>
            </div>

            <div className='alert_btns'>
              <button onClick={closeAlert}>Okay</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
